const text1 = document.getElementById('embroidery_add');
const text2 = document.getElementById('embroidery_text');
if (!text1 || !text2) return;
const checkboxWrapper = document.querySelector('.product-embroidery .form-field__checkbox');
let previousValue = text2.value;

text2.addEventListener('input', (e) => handleInput(e));
text2.addEventListener('paste', (e) => handlePaste(e));
text1.addEventListener('change', () => copyTextValue());

function copyTextValue(e) {
  const text2Value = text2.value;

  const charEL = document.querySelector('.product-embroidery_char span');

  if (checkboxWrapper) {
    if (text2Value) {
      checkboxWrapper.classList.remove('form-field__checkbox--disabled');
    } else {
      text1.checked = false;
      checkboxWrapper.classList.add('form-field__checkbox--disabled');
    }
  }

  if (charEL) charEL.innerHTML = text2Value.length;
  text1.value = text1.checked ? text2Value : '';
}

function handleInput(event) {
  const text2Value = text2.value;
  const allowedCharsRegex = /^(?:[A-Za-z0-9æøåÆØÅ!()+,.:?‘][A-Za-z0-9æøåÆØÅ!()+,.:?‘ ]*)*[A-Za-z0-9æøåÆØÅ!()+,.:?‘]?$/;

  if (!allowedCharsRegex.test(text2Value)) {
    if (event) event.preventDefault();
    text2.value = previousValue;
    return false;
  } else {
    previousValue = text2.value;
    copyTextValue();
  }
}

function handlePaste(event) {
  const pastedText = (event.clipboardData || window.clipboardData).getData('text');
  const allowedCharsRegex = /^(?:[A-Za-z0-9æøåÆØÅ!()+,.:?‘]+(?: [A-Za-z0-9æøåÆØÅ!()+,.:?‘]+)*[A-Za-z0-9æøåÆØÅ!()+,.:?‘]?)?$/;

  if (!allowedCharsRegex.test(pastedText)) {
    if (event) event.preventDefault();
    return false;
  } else {
    copyTextValue();
  }
}

window.addEventListener('load', function () {
  copyTextValue();
});
